import Vue from 'vue'
import Router from 'vue-router'
// RouterTab 内置路由
import { RouterTabRoutes } from 'vue-router-tab'

// 引入布局框架组件
import Frame from '../components/layout/Frame.vue'

// 异步加载页面组件
const importPage = view => () => import(/* webpackChunkName: "p-[request]" */ `../views/${view}.vue`)

import Login from '../components/Login/Login'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            component: Login,
            name: 'Login',
            meta: {
                title: '物联平台-登录'
                //title:'Narada platform - Login '
            }
        },
        {
            path: '/index',
            component: importPage('home/index'),
            meta: {
                title: 'HOME', // 页签标题
                icon: 'el-icon-s-home', // 页签图标，可选
                tips: 'HOME', // 页签提示，可选，如未设置则跟title一致
                aliveId: 'fullPath', // 路由打开页签规则，可选
            }
        },
        {
            path: '/',
            redirect: '/index',

            // 父路由组件内必须包含 <router-tab>
            component: Frame,

            // 子路由里配置需要通过页签打开的页面路由
            children: [

                // 引入 RouterTab 内置路由以支持 iframe 页签
                ...RouterTabRoutes,
                // {
                //     path: '/index',
                //     component: importPage('home/index'),
                //     meta: {
                //         title: 'HOME', // 页签标题
                //         icon: 'el-icon-s-home', // 页签图标，可选
                //         tips: 'HOME', // 页签提示，可选，如未设置则跟title一致
                //         aliveId: 'fullPath', // 路由打开页签规则，可选
                //     }
                // },
                {
                    path: '/menu',
                    component: importPage('menu/index'),
                    meta: {
                        title: 'MenuManage', // 页签标题
                        icon: 'el-icon-menu', // 页签图标，可选
                        tips: '菜单管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/devicetype',
                    component: importPage('devicetype/index'),
                    meta: {
                        title: '设备类型管理', // 页签标题
                        icon: 'el-icon-s-operation', // 页签图标，可选
                        tips: '设备类型管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/adddevicetype',
                    component: importPage('devicetype/add'),
                    meta: {
                        title: '添加设备类型', // 页签标题
                        icon: 'el-icon-s-operation', // 页签图标，可选
                        tips: '设备类型管理-添加', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/editdevicetype',
                    component: importPage('devicetype/edit'),
                    meta: {
                        title: '修改设备类型', // 页签标题
                        icon: 'el-icon-s-operation', // 页签图标，可选
                        tips: '设备类型管理-修改', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/setdevicetypeparam',
                    component: importPage('devicetype/setParam'),
                    meta: {
                        title: '设置参数', // 页签标题
                        icon: 'el-icon-s-operation', // 页签图标，可选
                        tips: '设备类型管理-设置参数', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/setdevicetypealarm',
                    component: importPage('devicetype/setAlarm'),
                    meta: {
                        title: '告警设置', // 页签标题
                        icon: 'el-icon-document-copy', // 页签图标，可选
                        tips: '设备类型管理-告警设置', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/project',
                    component: importPage('project/index'),
                    meta: {
                        title: '项目管理', // 页签标题
                        icon: 'el-icon-document-copy', // 页签图标，可选
                        tips: '项目管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/project2',
                    component: importPage('project/index2'),
                    meta: {
                        title: '二级项目', // 页签标题
                        icon: 'el-icon-document-copy', // 页签图标，可选
                        tips: '项目管理-二级项目', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/project3',
                    component: importPage('project/index3'),
                    meta: {
                        title: '三级项目', // 页签标题
                        icon: 'el-icon-document-copy', // 页签图标，可选
                        tips: '项目管理-三级项目', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/projectinfo',
                    component: importPage('project/info'),
                    meta: {
                        title: '设备详情', // 页签标题
                        icon: 'el-icon-document-copy', // 页签图标，可选
                        tips: '项目管理-设备详情', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/alarminfo',
                    component: importPage('project/alarm'),
                    meta: {
                        title: '项目详情', // 页签标题
                        icon: 'el-icon-document-copy', // 页签图标，可选
                        tips: '项目管理-历史告警', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/projectnewinfo',
                    component: importPage('project/new_info'),
                    meta: {
                        title: '项目详情', // 页签标题
                        icon: 'el-icon-document-copy', // 页签图标，可选
                        tips: '项目管理-详情', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/deviceinfo',
                    component: importPage('project/device'),
                    meta: {
                        title: '设备详情', // 页签标题
                        icon: 'el-icon-coin', // 页签图标，可选
                        tips: '项目管理-设备详情', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/supplier',
                    component: importPage('supplier/index'),
                    meta: {
                        title: '用户管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '用户管理-用户管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/addsupplier',
                    component: importPage('supplier/add'),
                    meta: {
                        title: '添加用户管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '用户管理-添加用户管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/editsupplier',
                    component: importPage('supplier/edit'),
                    meta: {
                        title: '修改用户管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '用户管理-修改用户管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/settingCenter',
                    component: importPage('settingCenter/index'),
                    meta: {
                        title: '设置中心', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/ruleManagement',
                    component: importPage('ruleManagement/index'),
                    meta: {
                        title: '规则管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '用户管理-修改用户管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/ruleManagementDomainRules',
                    component: importPage('ruleManagement/domainRules'),
                    meta: {
                        title: '域名规则', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '用户管理-修改用户管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/ruleManagementIPRules',
                    component: importPage('ruleManagement/ipRules'),
                    meta: {
                        title: 'ip规则', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '用户管理-修改用户管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/ruleManagementSNRules',
                    component: importPage('ruleManagement/batterySNRules'),
                    meta: {
                        title: '电池SN规则', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '用户管理-修改用户管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/adminuser',
                    component: importPage('adminuser/index'),
                    meta: {
                        title: '管理员管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '管理员管理-管理员管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/addadminuser',
                    component: importPage('adminuser/add'),
                    meta: {
                        title: '添加管理员管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '管理员管理-添加管理员管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/editadminuser',
                    component: importPage('adminuser/edit'),
                    meta: {
                        title: '修改管理员管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '管理员管理-修改管理员管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/logs',
                    component: importPage('logs/index'),
                    meta: {
                        title: '日志管理', // 页签标题
                        icon: 'el-icon-user-solid', // 页签图标，可选
                        tips: '日志管理-日志管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                }
                ,
                {
                    path: '/upgrade',
                    component: importPage('upgrade/index'),
                    meta: {
                        title: '升级版本管理', // 页签标题
                        icon: 'el-icon-upload', // 页签图标，可选
                        tips: '版本管理-升级版本管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/external',
                    component: importPage('upgrade/external'),
                    meta: {
                        title: '外部设备升级管理', // 页签标题
                        icon: 'el-icon-upload', // 页签图标，可选
                        tips: '版本管理-外部设备升级管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/upgradedevice',
                    component: importPage('upgrade/device'),
                    meta: {
                        title: '设备升级管理', // 页签标题
                        icon: 'el-icon-upload', // 页签图标，可选
                        tips: '版本管理-设备升级管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/devicelist',
                    component: importPage('project/devicelist'),
                    meta: {
                        title: '设备列表', // 页签标题
                        icon: 'el-icon-coin', // 页签图标，可选
                        tips: '项目管理-设备列表', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/devicemap',
                    component: importPage('project/deviceMap'),
                    meta: {
                        title: '设备分布', // 页签标题
                        icon: 'el-icon-coin', // 页签图标，可选
                        tips: '项目管理-设备分布', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/devicemanagement',
                    component: importPage('device/index'),
                    meta: {
                        title: '设备管理', // 页签标题
                        icon: 'el-icon-cpu', // 页签图标，可选
                        tips: '设备管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/newdevicemanagement',
                    component: importPage('device/list'),
                    meta: {
                        title: '设备列表', // 页签标题
                        icon: 'el-icon-cpu', // 页签图标，可选
                        tips: '设备列表', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/areaManagement',
                    component: importPage('device/areaManage'),
                    meta: {
                        title: '区域管理', // 页签标题
                        icon: 'el-icon-cpu', // 页签图标，可选
                        tips: '区域管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/iccidmanagement',
                    component: importPage('device/ICCID'),
                    meta: {
                        title: 'ICCID管理', // 页签标题
                        icon: 'el-icon-document-add', // 页签图标，可选
                        tips: 'ICCID管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/activityalarm',
                    component: importPage('alarm/activity'),
                    meta: {
                        title: '活动告警监控', // 页签标题
                        icon: 'el-icon-cpu', // 页签图标，可选
                        tips: '运行监控-活动告警监控', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/historyalarm',
                    component: importPage('alarm/history'),
                    meta: {
                        title: '历史告警监控', // 页签标题
                        icon: 'el-icon-cpu', // 页签图标，可选
                        tips: '运行监控-历史告警监控', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/historical',
                    component: importPage('historical/index'),
                    meta: {
                        title: '数据统计', // 页签标题
                        icon: 'el-icon-cpu', // 页签图标，可选
                        tips: '数据统计-数据统计', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/systemlang',
                    component: importPage('systemlang/index'),
                    meta: {
                        title: '语言管理', // 页签标题
                        icon: 'el-icon-chat-square', // 页签图标，可选
                        tips: '系统管理-语言管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
                {
                    path: '/systemlangtype',
                    component: importPage('systemlang/type'),
                    meta: {
                        title: '语言类型管理', // 页签标题
                        icon: 'el-icon-chat-square', // 页签图标，可选
                        tips: '系统管理-语言类型管理', // 页签提示，可选，如未设置则跟title一致
                        aliveId: 'fullPath', // 路由打开页签规则，可选
                    }
                },
            ]
        }
    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js